import React, { useState, useEffect, useCallback } from "react";
import config from "./config";
import { QueryBuilder } from "./utils/QueryBuilder";
import { CssBaseline, Paper, Box, LinearProgress, ThemeProvider } from "@material-ui/core";
import Form from "./components/Form";
import Table from "./components/Table";
import moment from "moment";
import axios from "axios";
import "./css/react-date-range.css";
import theme from './utils/themeStyles';

const articleEndpoint = `${config.baseEndpoint}/api/companies/${config.companyID}/articles`;
const qb = new QueryBuilder();

function App() {
    const [initialised, setInitialised] = useState(false);
    const [loading, setLoading] = useState(true);
    const [constants, setConstants] = useState({});
    const [state, setState] = useState(() => {
        return {
            pageIndex: 0,
            searchString: '',
            startDate: undefined,
            endDate: undefined,
            category: 'all',
        };
    });

    const [data, setData] = useState({
        articleCount: 0,
        articles: [],
    });

    const getFirstArticle = () => {
        qb.setPageOrdering('order[publishedAt]', 'asc');
        qb.setItemsPerPage(1);

        return axios.get(`${articleEndpoint}?${qb.getQueryString()}`);
    };

    const getCategories = () => {
        return axios.get(`${config.baseEndpoint}/resources/categories.json`);
    };

    const setQuery = useCallback(() => {
        qb.setItemsPerPage(config.articlesPerPage);
        qb.setPageIndex(state.pageIndex + 1);

        if (state.searchString.length) {
            qb.setSearchString(state.searchString);
        }

        if (state.category !== '' && Number.isInteger(state.category)) {
            let codes = constants.initialCategories[state.category].code;
            if (Array.isArray(codes) && codes.length === 1) codes = [codes];
            qb.setCategory(codes);
        }

        if (state.startDate !== undefined && state.endDate !== undefined) {
            qb.setDate(state.startDate.toISOString(), state.endDate.toISOString());
        }
    }, [state, constants]);

    useEffect(() => {
        Promise.all([
            getCategories(),
            getFirstArticle()
        ]).then(([firstResponse, secondResponse]) => {
            const categoriesData = firstResponse.data;
            const firstArticleData = secondResponse.data;
            const startDate = moment(firstArticleData['hydra:member'][0]['publishedAt']);
            const endDate = moment();

            setConstants({
                initialStartDate: startDate,
                initialEndDate: endDate,
                initialCategories: categoriesData
            });

            setState(s => ({ ...s, startDate: startDate, endDate: endDate }));

            setInitialised(true);
        }).catch(error => console.log(error));
    }, []);

    useEffect(() => {
        setLoading(true);

        if (initialised) {
            setQuery();

            axios.get(`${articleEndpoint}?${qb.getQueryString()}`)
                .then(response => {
                    const data = response.data;
                    setData({
                        articleCount: data['hydra:totalItems'],
                        articles: data['hydra:member'],
                    });
                    setLoading(false);
                });
        }
    }, [initialised, setQuery, state]);

    return(
        <ThemeProvider theme={theme}>
            <CssBaseline />
                <Paper>
                    <Box>
                        {(!initialised && <LinearProgress />) ||
                            <>
                                {loading && <LinearProgress />}
                                <>
                                    <Form state={state} setState={setState} constants={constants} />
                                    <Table data={data} state={state} setState={setState} />
                                </>
                            </>
                        }
                    </Box>
                </Paper>
        </ThemeProvider>
    );
}

export default App;
